import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import MuiAutocomplete from '@material-ui/lab/Autocomplete';
import ArrowIcon from '@material-ui/icons/KeyboardArrowDown';

import './autocomplete.scss';

const icon = <ArrowIcon style={{ color: '#c5c8c9' }} />

const Autocomplete = (props) => {
  const {
    options = [],
    value,
    onChange,
    name,
    disabled = false,
    placeholder,
    multiple = false,
  } = props;

  const [inputValue, setInputValue] = useState(multiple ? [] : null);

  useEffect(() => {
    if (multiple) {
      if (!value || value.length === 0) {
        setInputValue([]);
      } else {
        setInputValue(options.filter((o) => value.includes(o.value)));
      }
    } else {
      if (!value) {
        setInputValue(null);
      } else {
        setInputValue(options.find((o) => o.value === value) || null);
      }
    }
  }, [value, options, multiple]);

  return <MuiAutocomplete
    id="autocomplete"
    name={name}
    options={options}
    getOptionLabel={(option) => option.label}
    multiple={multiple}
    // defaultValue={value ? options?.find((o) => o.value === value) : null}
    value={inputValue}
    onChange={(event, option) => {
      setInputValue(option);
      onChange(multiple ? option?.map((o) => o.value) : option.value);
    }}
    popupIcon={icon}
    disableClearable
    disabled={disabled}
    style={{ paddingLeft: '16px !important' }}
    renderOption={(option) => (
      <div style={{ paddingTop: '8px', paddingBottom: '8px' }}>
        {option.label}
      </div>
    )}
    renderInput={(params) => (
      <TextField
        {...params}
        className={`autocomplete__input ${multiple ? 'autocomplete__input--multiple' : ''}`}
        style={{
          color: value ? '#0b0b0b' : '#a7a7a7 !important',
        }}
        placeholder={placeholder}
      />
    )}
  />
}

export default Autocomplete;
